import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Application from './views/Application.vue'
import Feedback from './views/Feedback.vue'
import Contact from './views/Contact.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/index',
            name: 'home',
            component: Home
        },
        {
            path: '/application/:id',
            name: 'application',
            component: Application
        },
        {
            path: '/feedback',
            name: 'feedback',
            component: Feedback
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
})